import { useQuery } from '@tanstack/react-query'
import api from '../api/client'

/**
 * Fetches all 7 forecast days in one request.
 * Returns { available_dates, geometries, by_date } — date switching is local state.
 */
export function usePredictionAll() {
  return useQuery({
    queryKey: ['predictions', 'all'],
    queryFn: async () => {
      const { data } = await api.get('/predictions/all')
      return data
    },
    staleTime: 5 * 60 * 1000,
    gcTime:    15 * 60 * 1000,
    retry: 2,
  })
}
